import React from 'react';
import PropTypes from 'prop-types';

import Page from 'components/Page';

import './style.css';

/* eslint-disable max-len */
const LeadInvite = ({login, invite}) => (
  <section className="pageContainer">
    <Page>
      <section styleName="inviteContainer">
        <img src={invite.deal.sponsor.image} alt={invite.deal.sponsor.name} />
        <h3>{invite.deal.sponsor.name} invited you to syndicate {invite.deal.name}</h3>
      </section>
      <p styleName="login">
        To see this deal, you need to <a onClick={login} role="button" tabIndex="0" data-test="login">login</a>
      </p>
    </Page>
  </section>
);
/* eslint-enable max-len */

LeadInvite.propTypes = {
  login: PropTypes.func.isRequired,
  invite: PropTypes.object,
};

export default LeadInvite;



// WEBPACK FOOTER //
// ./web/flows/lead/invite/component.js